import React from 'react';
import PropTypes from 'prop-types'
import {injectIntl} from 'react-intl'
import DXSelectFilter from '../DXSelectFilter/DXSelectFilter'
import DXFilterConfig from '../DXFilterConfig'
import constants from '../../constants'

const propTypes = {
  equality: PropTypes.string,
  selected: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  selected: [],
};

class DXCustomerTypeCSAFilter extends React.Component {
  
  render() {
    const {selected, onChange, intl, equality} = this.props;
    const config = DXCustomerTypeCSAFilter.getConfig(intl, equality);
    return (
      <DXSelectFilter selected={selected}
                      title={config.title}
                      values={config.values}
                      onChange={onChange}
                      multi={config.multi}
      />
    )
  }
}

DXCustomerTypeCSAFilter.propTypes = propTypes;
DXCustomerTypeCSAFilter.defaultProps = defaultProps;
DXCustomerTypeCSAFilter.getLabel = (intl, selectedValues) => {
  return DXSelectFilter.getLabel(intl, 'filter.types.', selectedValues);
};
DXCustomerTypeCSAFilter.applyToQueryParams = (queryParams, selectedValues) => {
  selectedValues[0] && (queryParams['customerType'] = selectedValues[0]);
  return queryParams;
};
DXCustomerTypeCSAFilter.getConfig = (intl, equality) => {
  let config = new DXFilterConfig({
    name: 'csaType',
    selected: [],
    property: 'customer.type',
    title: intl.formatMessage({id: 'filter.type'}),
    disabled: false,
    equalityStatus: false,
    multi: false
  });
  
  if (equality === constants.FILTER_EQUALITY_EQUALS) {
    config.addFilterValue('retail', intl.formatMessage({id: 'filter.types.retail'}));
    config.addFilterValue('wholesale', intl.formatMessage({id: 'filter.types.wholesale'}));
  }
  
  return config;
};

export default injectIntl(
  DXCustomerTypeCSAFilter
);
